import { render, staticRenderFns } from "./wareHouse.vue?vue&type=template&id=6080147e"
import script from "./wareHouse.vue?vue&type=script&lang=js"
export * from "./wareHouse.vue?vue&type=script&lang=js"
import style0 from "./wareHouse.vue?vue&type=style&index=0&id=6080147e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports